import * as Types from '../../network/graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReportIssueFromSellerMutationVariables = Types.Exact<{
  input: Types.ReportIssueFromSellerInput;
}>;


export type ReportIssueFromSellerMutation = { __typename?: 'Mutation', reportIssueFromSeller: { __typename?: 'ReportIssueFromSellerPayload', ok: boolean } };


export const ReportIssueFromSellerDocument = gql`
    mutation ReportIssueFromSeller($input: ReportIssueFromSellerInput!) {
  reportIssueFromSeller(input: $input) {
    ok
  }
}
    `;
export type ReportIssueFromSellerMutationFn = Apollo.MutationFunction<ReportIssueFromSellerMutation, ReportIssueFromSellerMutationVariables>;

/**
 * __useReportIssueFromSellerMutation__
 *
 * To run a mutation, you first call `useReportIssueFromSellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportIssueFromSellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportIssueFromSellerMutation, { data, loading, error }] = useReportIssueFromSellerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportIssueFromSellerMutation(baseOptions?: Apollo.MutationHookOptions<ReportIssueFromSellerMutation, ReportIssueFromSellerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportIssueFromSellerMutation, ReportIssueFromSellerMutationVariables>(ReportIssueFromSellerDocument, options);
      }
export type ReportIssueFromSellerMutationHookResult = ReturnType<typeof useReportIssueFromSellerMutation>;
export type ReportIssueFromSellerMutationResult = Apollo.MutationResult<ReportIssueFromSellerMutation>;
export type ReportIssueFromSellerMutationOptions = Apollo.BaseMutationOptions<ReportIssueFromSellerMutation, ReportIssueFromSellerMutationVariables>;